import React from 'react'
import styled from 'styled-components'
import { Box } from '../../../../../core-components'
import { ThemeColors, ThemeShadows } from '../../../../../theme'

type Variant = 'major' | 'minor'

type Props = {
  isDisabled?: boolean
  isFocused?: boolean
  isSelected: boolean
  variant: Variant
}

export const Radio = ({ isSelected, isDisabled = false, variant, isFocused = false }: Props) => {
  return (
    <Box
      aria-hidden
      w={4}
      h={4}
      position='relative'
      borderRadius='full'
      flexShrink={0}
      boxShadow={getRadioShadow(isSelected, isDisabled, isFocused)}
      bg={getRadioBackground(isSelected, isDisabled, variant)}
    >
      <StyledInnerRadioCircle
        isSelected={isSelected}
        w={2}
        h={2}
        position='absolute'
        top='4px'
        left='4px'
        bg='icon/on-color'
        borderRadius='full'
      />
    </Box>
  )
}

const getRadioBackground = (
  isSelected: boolean,
  isDisabled: boolean,
  variant: Variant
): ThemeColors | undefined => {
  if (!isSelected) {
    return undefined
  }
  if (isDisabled) {
    if (variant === 'major') {
      return 'bg/select-indicator-major-disabled'
    }
    return 'bg/select-indicator-minor-disabled'
  }
  if (variant === 'major') {
    return 'bg/select-indicator-major'
  }
  return 'bg/select-indicator-minor'
}

const getRadioShadow = (
  isSelected: boolean,
  isDisabled: boolean,
  isFocused: boolean
): ThemeShadows | undefined => {
  if (isFocused) {
    return 'border/focus-indicator'
  }
  if (isSelected) {
    return undefined
  }
  if (isDisabled) {
    return 'border/select-item-disabled'
  }
  return 'border/select-item'
}

const StyledInnerRadioCircle = styled(Box)<{ isSelected: boolean }>`
  transition: all 0.2s ease;
  transform: scale(${({ isSelected }) => (isSelected ? 1 : 0)});
`
